// extracted by mini-css-extract-plugin
export var anchorPointer = "HealthSection-module--anchorPointer--5e688";
export var bgOverlay = "HealthSection-module--bgOverlay--c88c4";
export var columnContainer1 = "HealthSection-module--columnContainer1--d6ff8";
export var columnContainer2 = "HealthSection-module--columnContainer2--17e67";
export var container = "HealthSection-module--container--e9fcb";
export var ctaWrapper = "HealthSection-module--ctaWrapper--e1030";
export var focusVisible = "HealthSection-module--focus-visible--eb500";
export var headlineContainer = "HealthSection-module--headlineContainer--5c852";
export var horizontalLine = "HealthSection-module--horizontalLine--2ec4a";
export var iconGrid = "HealthSection-module--iconGrid--71863";
export var iconImage = "HealthSection-module--iconImage--d1860";
export var iconItem = "HealthSection-module--iconItem--84d7e";
export var iconTitle = "HealthSection-module--iconTitle--96643";
export var imageBlock = "HealthSection-module--imageBlock--07631";
export var imageContainer = "HealthSection-module--imageContainer--4feed";
export var innerTextBlock = "HealthSection-module--innerTextBlock--7b3b7";
export var logoGrid = "HealthSection-module--logoGrid--d172a";
export var logoImage = "HealthSection-module--logoImage--45a5e";
export var logoItem = "HealthSection-module--logoItem--880d2";
export var mediaContainer = "HealthSection-module--mediaContainer--b7a26";
export var mediaTitle = "HealthSection-module--mediaTitle--7bfb8";
export var mobileImageBuffer = "HealthSection-module--mobileImageBuffer--516b9";
export var mobilePictureContainer = "HealthSection-module--mobilePictureContainer--aaedd";
export var pictureContainer = "HealthSection-module--pictureContainer--b12ed";
export var pictureImg = "HealthSection-module--pictureImg--8b7a9";
export var starIcon = "HealthSection-module--starIcon--4a7b2";
export var stars = "HealthSection-module--stars--97881";
export var subHeadlineContainer1 = "HealthSection-module--subHeadlineContainer1--8ac6b";
export var subHeadlineContainer2 = "HealthSection-module--subHeadlineContainer2--56489";
export var textBlock = "HealthSection-module--textBlock--26684";